import mag from "./pd-property-mag";
import onSale from "./pd-property-on-sale";
import other from "./pd-property-other";

export default {
  ...mag,
  ...onSale,
  ...other,
}